// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IPromo {
  /** Промо текст **/
  text: string;
  /** Тренд динамики цен (увеличение/уменьшение/стабильность) **/
  diff: EDiff;
}

export enum EDiff {
  /** Увеличение **/
  'Increase' = 'increase',
  /** Уменьшение **/
  'Decrease' = 'decrease',
  /** Без изменения **/
  'NoChange' = 'noChange',
}
